import { Phone, Mail, MessageCircle } from "lucide-react";
import { useT } from "../../i18n/LanguageContext";

export default function Anfitrioes() {
  const { t } = useT();
  return (
    <section className="bg-noite text-[#faf6ee] border-t border-white/5" data-testid="anfitrioes-section">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-[1.1fr_2fr] gap-8 items-center">
        <div className="reveal">
          <p className="text-sm text-[#faf6ee]/70">
            {t.hosts.eyebrow}{" "}
            <em className="font-display text-[#e3b25b] text-xl">{t.hosts.names}</em>
          </p>
          <p className="mt-3 text-sm text-[#faf6ee]/65 leading-relaxed">{t.hosts.description}</p>
        </div>

        <div className="grid sm:grid-cols-3 gap-4 reveal">
          <a
            href="tel:+351965209781"
            className="bg-[#1a2c5c]/55 hover:bg-[#1a2c5c]/80 transition rounded-2xl p-5 ring-1 ring-white/10 text-center"
            data-testid="contact-carlos"
          >
            <div className="flex items-center justify-center gap-2 text-[#e3b25b] text-[10px] font-bold uppercase tracking-[0.22em]">
              <Phone size={12} /> Carlos Simões
            </div>
            <p className="font-display text-xl mt-2">+351 965 209 781</p>
            <p className="text-[10px] text-[#faf6ee]/55 mt-1 flex items-center justify-center gap-1">
              <MessageCircle size={10} /> WhatsApp
            </p>
          </a>
          <a
            href="tel:+351965488960"
            className="bg-[#1a2c5c]/55 hover:bg-[#1a2c5c]/80 transition rounded-2xl p-5 ring-1 ring-white/10 text-center"
            data-testid="contact-rute"
          >
            <div className="flex items-center justify-center gap-2 text-[#e3b25b] text-[10px] font-bold uppercase tracking-[0.22em]">
              <Phone size={12} /> Rute Gonçalves
            </div>
            <p className="font-display text-xl mt-2">+351 965 488 960</p>
            <p className="text-[10px] text-[#faf6ee]/55 mt-1 flex items-center justify-center gap-1">
              <MessageCircle size={10} /> WhatsApp
            </p>
          </a>
          <a
            href="mailto:mexihome5@hotmail.com"
            className="bg-[#1a2c5c]/55 hover:bg-[#1a2c5c]/80 transition rounded-2xl p-5 ring-1 ring-white/10 text-center"
            data-testid="contact-email"
          >
            <div className="flex items-center justify-center gap-2 text-[#e3b25b] text-[10px] font-bold uppercase tracking-[0.22em]">
              <Mail size={12} /> Email
            </div>
            <p className="font-display text-lg mt-2 break-all">mexihome5@hotmail.com</p>
            <p className="text-[10px] text-[#faf6ee]/55 mt-1">&lt; 24h</p>
          </a>
        </div>
      </div>
    </section>
  );
}
